export default __webpack_public_path__ + "static/media/badge_app.9d0dab6f.svg";